
(function() {

    "use strict";
    angular.module("app")
        .service("wizardService",
            [
                "$http", function($http) {

                    this.attach = function() {
                        return $http.post("api/forceSSO/attach")
                            .then(function(response) {
                                    return response.data;
                                },
                                function(response) {
                                    throw (response.data);
                                });
                    };

                }
            ]
        );
})();